import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputDate } from 'src/components/common/PbrInputDate/PbrInputDate';
import { Moment } from "moment";

interface IBirthDateComponent {
    customClass?: string
    request: Moment
    onChange: (value: Moment) => void;
    required?: boolean;
    label: string;
    name: string;
}

export function BirthDateComponent(props: IBirthDateComponent & FormComponentProps) {

    return (
        <PbrInputDate
            className={props.customClass}
            name={props.name}
            formWrapper={props.form}
            formItemProps={{ label: props.label }}
            placeholder={props.label}
            value={props.request}
            onChange={e => props.onChange(e)}
            isRequired={props.required}
            requiredMessage={"Data de nascimento é obrigatória"}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/BirthDateComponent/BirthDateComponent.tsx